// extracted by mini-css-extract-plugin
export default {"date-container":"bksV9","dateContainer":"bksV9"};